export default __webpack_public_path__ + "static/media/Aboutt.386035ae.png";